import { render, staticRenderFns } from "./AlbumsChat.vue?vue&type=template&id=60c769f9&scoped=true&lang=html&"
import script from "./AlbumsChat.vue?vue&type=script&lang=js&"
export * from "./AlbumsChat.vue?vue&type=script&lang=js&"
import style0 from "./AlbumsChat.vue?vue&type=style&index=0&id=60c769f9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c769f9",
  null
  
)

export default component.exports